export const getPromotionUrl = (href: string, promoCode?: string) =>
  href.replace(':promoCode', promoCode || '')
